<template>
    <div class="publication__editor">

        <div class="publication__editor-wrap  d-flex">
            <div class="publication__editor-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">{{$store.getters.t('homestays_store_form_title')}}</div>
                    <div class="publication__fieldset-input">
                        <input type="text" v-model="$v.name.$model" :placeholder="$store.getters.t('homestays_store_form_title')">
                    </div>
                    <div class="text-danger" v-show="$v.name.$error">{{$store.getters.t('homestays_store_form_enter_title')}}</div>
                </div>
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">{{$store.getters.t('homestays_store_form_street')}}</div>
                    <div class="publication__fieldset-input">
                        <input type="text" v-model="$v.street_address.$model" :placeholder="$store.getters.t('homestays_store_form_enter_street')">
                    </div>
                    <div class="text-danger" v-show="$v.street_address.$error">{{$store.getters.t('homestays_store_form_enter_street')}}</div>
                </div>
                <div class="publication__fieldset publication__fieldset--textarea-large">
                    <div class="publication__fieldset-title">{{$store.getters.t('homestays_store_form_description')}}</div>
                    <div class="publication__fieldset-input">
                        <textarea v-model="$v.description.$model" :placeholder="$store.getters.t('homestays_store_form_description')"></textarea>
                    </div>
                    <div class="text-danger" v-show="$v.description.$error">{{$store.getters.t('homestays_store_form_description_min')}}</div>
                </div>

                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">{{$store.getters.t('homestays_store_form_days_count')}}</div>
                    <div class="publication__fieldset-row d-flex">
                        <div class="publication__fieldset-row-item">
                            <div class="publication__fieldset-input">
                                <input type="text" v-model="$v.min_duration.$model" :placeholder="$store.getters.t('homestays_store_form_from')">
                            </div>
                            <div class="text-danger" v-show="$v.min_duration.$error">{{$store.getters.t('homestays_store_form_enter_min_days')}}</div>
                        </div>
                        <div class="publication__fieldset-row-item">
                            <div class="publication__fieldset-input">
                                <input type="text" v-model="$v.max_duration.$model" :placeholder="$store.getters.t('homestays_store_form_to')">
                            </div>
                            <div class="text-danger" v-show="$v.max_duration.$error">{{$store.getters.t('homestays_store_form_max_less_min')}}</div>
                        </div>
                    </div>

                </div>

            </div>
            <div class="publication__editor-item">

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('homestays_store_form_type')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.types">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.type.$model" :value="key">
                                <span class="circle"></span>
                                {{$store.getters.t(key === 'apartment' ? 'homestays_store_form_type_apartment' : (key === 'enclosure' ? 'homestays_store_form_type_enclosure' : 'common_unknown'))}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.type.$error">{{$store.getters.t('homestays_store_form_enter_type')}}</div>

                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('homestays_store_form_pricing')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.charge_categories">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.charge_category.$model" :value="key">
                                <span class="circle"></span>
                                {{$store.getters.t(key === 'free' ? 'homestays_store_form_free' : (key === 'paid_for' ? 'homestays_store_form_paid' : (key === 'cost_recovery' ? 'facilities_store_form_cost_recovery' : 'common_unknown')))}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.charge_category.$error">{{$store.getters.t('homestays_store_form_choose_tariff')}}</div>

                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('homestays_store_form_reception')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.reception_statuses">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.reception_status.$model" :value="key">
                                <span class="circle"></span>
                                {{$store.getters.t(key === 'open' ? 'homestays_store_form_reception_open' : (key === 'closed' ? 'homestays_store_form_reception_closed' : 'common_unknown'))}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.reception_status.$error">{{$store.getters.t('homestays_store_form_enter_status')}}</div>

                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('homestays_store_form_view_mode')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.view_modes">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.view_mode.$model" :value="key">
                                <span class="circle"></span>
                                {{$store.getters.t(key === 'homestay' ? 'homestays_store_form_view_mode_homestay' : (key === 'user' ? 'homestays_store_form_view_mode_user' : 'common_unknown'))}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.view_mode.$error">{{$store.getters.t('homestays_store_form_enter_view_mode')}}</div>

                </div>

                <div class="publication__section-item" v-if="petsCategories.length" >
                    <div class="publication__section-title">{{$store.getters.t('homestays_store_form_pet_categories')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="category in petsCategories">
                            <label class="d-flex">
                                <input type="checkbox" v-model="$v.pet_categories.$model" :value="category.id">
                                <span class="square"></span>
                                {{category.name}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.pet_categories.$error">{{$store.getters.t('homestays_store_form_enter_category')}}</div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>

import { required, maxLength, minLength, minValue } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "HomestaysForm",
    mixins: [ StateMixin ],
    props: ['server'],


    data(){
        return{
            petsCategories: []
        }
    },

    async mounted(){
        await this.getPetsCategories()
            .then(() => { this.$parent.handleSliderHeight() });
    },

    computed: {

        serverDictionary(){ return this.server.dictionaries },

        name: {
            get() { return this.GET_BY_KEY('name') },
            set( val ) {
                this.SET_BY_KEY({key: 'name', data: val})
            }
        },

        description: {
            get() { return this.GET_BY_KEY('description') },
            set( val ) {
                this.SET_BY_KEY({key: 'description', data: val})
            }
        },

        street_address: {
            get() { return this.GET_BY_KEY('street_address') },
            set( val ) {
                this.SET_BY_KEY({key: 'street_address', data: val})
            }
        },

        type: {
            get() { return this.GET_BY_KEY('type') },
            set( val ) {
                this.SET_BY_KEY({key: 'type', data: val})
            }
        },

        charge_category: {
            get() { return this.GET_BY_KEY('charge_category') },
            set( val ) {
                this.SET_BY_KEY({key: 'charge_category', data: val})
            }
        },

        reception_status: {
            get() { return this.GET_BY_KEY('reception_status') },
            set( val ) {
                this.SET_BY_KEY({key: 'reception_status', data: val})
            }
        },

        view_mode: {
            get() { return this.GET_BY_KEY('view_mode') },
            set( val ) {
                this.SET_BY_KEY({key: 'view_mode', data: val})
            }
        },

        pet_categories: {
            get() { return this.GET_BY_KEY('pet_categories') },
            set( val ) {
                this.SET_BY_KEY({key: 'pet_categories', data: val})
            }
        },

        min_duration: {
            get() { return this.GET_BY_KEY('min_duration') },
            set( val ) {
                this.SET_BY_KEY({key: 'min_duration', data: val})
            }
        },

        max_duration: {
            get() { return this.GET_BY_KEY('max_duration') },
            set( val ) {
                this.SET_BY_KEY({key: 'max_duration', data: val})
            }
        },


    },

    methods:{

        async getPetsCategories(){

            try{

                const { data: { success = false, data = [] } } = await axios.get( '/api/pets/categories' );

                if( success ) this.petsCategories = data;


            } catch ( _e ){

                console.log( _e );

            }

        },

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }
    },

    validations: {
        type:             { required },
        view_mode:        { required },
        charge_category:  { required },
        reception_status: { required },

        min_duration:     { required, minValue: minValue(1) },
        max_duration:     {
            custom: function (value) {

                if(value !== null && +value < +this.min_duration){

                    if(value === ''){
                        value = null
                        return true
                    }

                    return false
                }


                return true
            }
        },

        pet_categories:   { required, minLength: minLength(1) },
        name:             { required, maxLength: maxLength(256) },
        street_address:   { required, maxLength: maxLength(256) },
        description:      { required, minLength: minLength(30), maxLength: maxLength(1000) },
    }


}
</script>

<style scoped>

</style>
